import React from "react";
import { Header, Progress, Button, Icon, Label, Message } from "semantic-ui-react";
import { BackgroundJob } from "../queries/backgroundJobs";
import { addCommasToNumber } from "../../../lib/addCommasToNumber";

interface IJobProgress {
  title: string;
  isTest?: boolean;
  currentStep?: number;
  totalSteps?: number;
  stepProgressMessage?: string | null;
  currentRecords?: number;
  totalRecords?: number;
  errorCount?: number;
  progress?: number;
  showCancelJob?: boolean;
  cancelJob?: () => void;
  isCancelling?: boolean;
  jobError?: BackgroundJob["jobError"];
}

export const JobProgress = ({
  title,
  isTest,
  currentStep,
  stepProgressMessage,
  currentRecords,
  totalRecords,
  totalSteps,
  errorCount,
  progress,
  showCancelJob = true,
  cancelJob,
  isCancelling,
  jobError,
}: IJobProgress) => {
  const showTotalRecords = currentRecords && totalRecords && currentRecords <= totalRecords;
  const currentRecordNumberString = addCommasToNumber(currentRecords ?? 0);
  const totalRecordNumberString = addCommasToNumber(totalRecords ?? 0);
  const errorCountString = addCommasToNumber(errorCount ?? 0);
  return (
    <>
      <Header as='h4' className='justify-content'>
        {title}
        {isTest && (
          <Label basic circular>
            Test
          </Label>
        )}
      </Header>
      {!jobError && (
        <div className='tw-flex tw-justify-between'>
          <p className='subText tw-m-0'> {`Step ${currentStep} of ${totalSteps}: ${stepProgressMessage}`}</p>
          <p className='subText tw-m-0'>
            {showTotalRecords
              ? `${currentRecordNumberString} of ${totalRecordNumberString} Records`
              : `${currentRecordNumberString} Records`}
          </p>
        </div>
      )}
      {progress === -1 && !jobError && <Progress percent={100} indicating />}
      {progress !== -1 && !jobError && <Progress percent={progress} indicating />}
      {jobError && (
        <Message negative>
          <Message.Header>{jobError.name}</Message.Header>
          <p>{jobError.message}</p>
        </Message>
      )}
      <div className='tw-flex tw-items-center tw-justify-between'>
        {!!errorCount && (
          <div className='tw-flex tw-align-baseline'>
            <Icon color='red' name='exclamation circle' />
            <p className='subText'>{`${errorCountString} Errors`}</p>
          </div>
        )}
        {showCancelJob && !jobError && (
          <Button
            className='muted-tertiary'
            icon='close'
            content='Cancel Job'
            onClick={cancelJob}
            loading={isCancelling}
            disabled={isCancelling}
          />
        )}
      </div>
    </>
  );
};

export default JobProgress;
